
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import {
  Login,
  IMUUserMapping,
  IMUStudentMapping,
  IMUForgetPassword,
  IMUNewpassword,
  IMUUserCreate,
  Vendorlist,
  Internshiptopic,
  Addinternshiptopic
  // SFAChangePassword,
  // SFACondonation
} from "../Pages/IMU";



import ProtectedRoute from '../component/ProtectedRoute';

const IMURoutes = () => (

  <Routes>

    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<Login />} />
    <Route path="/forgetpassword" element={<IMUForgetPassword />} />
    <Route path="/imuusermapping" element={<ProtectedRoute element={<IMUUserMapping />} role={24} />} />
    <Route path="/imustudentmapping" element={<ProtectedRoute element={<IMUStudentMapping />} role={24} />} />
    <Route path="/imunewpassword" element={<IMUNewpassword />} />
    <Route path="/imuusercreate" element={<ProtectedRoute element={<IMUUserCreate />} role={24} />} />
    <Route path="/imuuseredit/:id" element={<ProtectedRoute element={<IMUUserCreate />} role={24} />} />
    <Route path="/vendorlist" element={<ProtectedRoute element={<Vendorlist />} role={24} />} />

    <Route path="/addinternshiptopic" element={<ProtectedRoute element={<Addinternshiptopic />} role={24} />} />
    <Route path="/editinternshiptopic/:id" element={<ProtectedRoute element={<Addinternshiptopic />} role={24} />} />
    <Route path="/internshiptopic" element={<ProtectedRoute element={<Internshiptopic />} role={24} />} />

    {/* <Route path="/sfachangepassword" element={<ProtectedRoute element={<SFAChangePassword />} role={22} />} />
    <Route path="/condonation" element={<ProtectedRoute element={<SFACondonation />} role={22} />} />  */}

  </Routes>

);

export default IMURoutes;

